import React from 'react';
import { Box } from '@mui/material';

import { Typography, Divider } from '@occc/ui-design-system';
import { ProductGroupFragment } from '@occc/graphql';

import { ProductGroupDetails } from './ProductGroupDetails';

interface ISelectedProductGroupsDetails {
  selectedProductGroups: ProductGroupFragment[];
}

// TODO: sync with designer and define colors according to DS.

export const SelectedProductGroupsDetails: React.FC<ISelectedProductGroupsDetails> = ({
  selectedProductGroups,
}) => {
  if (selectedProductGroups.length === 0) {
    return null;
  }

  const productHash: {
    [k: string]: ProductGroupFragment;
  } = {};

  selectedProductGroups.forEach((group) => (productHash[group.id] = group));

  const groupDetails = selectedProductGroups.map((group) => {
    const productDetails = productHash[group.id];
    return (
      <Box
        key={group.id}
        width='50%'
        mb={2}
        p={1}
        bgcolor='#fafafa'
        sx={(theme) => ({
          border: `1px solid ${theme.palette.divider}`,
        })}
      >
        <ProductGroupDetails productGroup={productDetails} />
      </Box>
    );
  });
  return (
    <Box>
      <Typography component='h4' variant='h6'>
        Selected Group Details
      </Typography>
      <Divider />
      {groupDetails}
    </Box>
  );
};
